export default {
    APP_DOC_TYPE_REQ : 'REQ',
    APP_DOC_STATUS_VALID : 'VALID',
    APP_DOC_STATUS_NOT_VALID : 'NOT_VALID',
    APP_DOC_STATUS_PROCESS : 'PROCESS',
    APP_DOC_STATUS_FOR_CHECK : 'FOR_CHECK',
};